import { useState } from "react";
import { Play, X } from "@phosphor-icons/react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Reveal } from "@/components/motion";
import { SHORTS } from "@/lib/data";

// Vertical YouTube Shorts grid with in-dialog player
const ShortsGrid = ({ items = SHORTS, columns = "grid-cols-2 md:grid-cols-3 lg:grid-cols-6" }) => {
  const [active, setActive] = useState(null);

  return (
    <>
      <div className={`grid gap-4 md:gap-5 ${columns}`}>
        {items.map((s, i) => (
          <Reveal key={s.id} delay={(i % 6) * 0.06}>
            <button
              onClick={() => setActive(s)}
              data-testid={`short-${s.id}`}
              className="group relative block aspect-[9/16] w-full overflow-hidden rounded-sm border border-black/10 bg-black"
            >
              <img
                src={s.cover}
                alt={s.title}
                className="absolute inset-0 h-full w-full object-cover opacity-95 transition-transform duration-[1.2s] ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-black/10" />
              <div className="absolute inset-0 flex items-center justify-center">
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-offwhite/95 text-ink shadow-[0_10px_30px_rgba(0,0,0,0.35)] transition-transform duration-500 group-hover:scale-110">
                  <Play weight="fill" size={20} />
                </span>
              </div>
              <span className="absolute left-4 top-4 rounded-sm bg-white/90 px-2 py-1 text-[0.55rem] font-bold uppercase tracking-[0.14em] text-ink">
                Reel
              </span>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <h4 className="font-display text-sm font-medium leading-tight text-white md:text-base">
                  {s.title}
                </h4>
              </div>
            </button>
          </Reveal>
        ))}
      </div>

      <Dialog open={!!active} onOpenChange={(v) => !v && setActive(null)}>
        <DialogContent
          className="max-w-[420px] overflow-hidden border-none bg-black p-0"
          data-testid="short-player"
        >
          {active && (
            <div className="relative">
              <div className="aspect-[9/16] w-full">
                <iframe
                  title={active.title}
                  src={`https://www.youtube.com/embed/${active.youtube}?autoplay=1&modestbranding=1&rel=0&playsinline=1&loop=1&playlist=${active.youtube}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  className="h-full w-full"
                />
              </div>
              <div className="flex items-center justify-between bg-ink px-4 py-3">
                <span className="text-sm font-medium text-offwhite">{active.title}</span>
                <a
                  href={`https://www.youtube.com/shorts/${active.youtube}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-[0.65rem] font-semibold uppercase tracking-[0.14em] text-gold hover:text-offwhite"
                >
                  Open ↗
                </a>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ShortsGrid;
